<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">我的充值科目</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>


        <van-panel v-for="item in list" :key="item.id"
                   :title="undefined === item.subject?'':item.subject.name">
            <div style="margin: 0 20px">
                模拟练习:<br>
                <div style="font-weight: 100">
                    开始时间:{{item.start_time}} <br>
                    过期时间:{{item.expired_time}}<br>
                </div>

                课程学习:<br>
                <div style="font-weight: 100">

                剩余:{{item.learn_duration}}分钟
                </div>


            </div>

        </van-panel>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabActive: 0,
                page: 1,
                listActive: [],

                loading: false,
                finished: false,
                error: false,
                error_text: "",
                searchValue: "",

                list: []
            };
        },
        created() {
            this.onLoad()
        },
        methods: {
            onLoad() {

                this.loading = true;
                this.$http.get("/wechat/user/vips").then(res => {
                    this.loading = false;
                    console.log(res.data);


                    this.list = res.data.data;
                });
            },
            getLearnTypeText(learn_type) {
                if (1 == learn_type) {
                    return "模拟练习"
                } else {
                    return "课程学习"
                }

            }
        }
    }
</script>
